<template>
  <div v-if="isLoading">
    <LoadingPlaceholder/>
  </div>
  <div v-else>
    <Breadcrumbs
      :breadcrumbs="[
     {title: this.$t(`menu.${serviceSlug}`), disabled: true},
     {title: this.$t('menu.iframe/blocks-builder'), active: true, meta: {type: 'string', value: `/${this.iframeService.slug}/${this.iframeService.slug}/blocks-builder`}},
     {title: $t('iframe.page_types.thanks_page'), disabled: true},
     {title: block.name, disabled: true}
   ]"/>

    <div>
      <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3"> {{$t('iframe.titles.update_block', {name: block.name})}} </h5>

      <BlockDetails
        v-model="blockForm"
        :form-errors="blockErrors"
        :clientOptions="clientOptions"
      />
    </div>



    <!-- Buttons row -->
    <div class="row d-flex justify--space-between mt-3 ml-3 mr-3">
      <va-button class="btn-cancel" @click="handleCancel">
        {{$t('iframe.actions.cancel')}}
      </va-button>

      <va-button @click="handleSave">
        {{$t('iframe.actions.save')}}
      </va-button>
    </div>
    <!-- --- --- --- -->
  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder";
import {IframeService} from "@/api/IframeService";
import BlockDetails from "@/components/iframe/blocks-builder/thanks/BlockDetails";
import IframeBlocksUpdateMixin from "@/mixins/IframeBlocksUpdateMixin";
import Errors from "@/utils/StandardErrors";

const errorsPrefix = 'iframe.blocks_builder.thanks_block.errors.'

export default {
  mixins: [IframeBlocksUpdateMixin],
  components: {BlockDetails, LoadingPlaceholder, Breadcrumbs},
  props: {
    serviceSlug: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      isLoading: true,
      isSubmiting: false,
      blockForm:{
        cta_text: null,
        cta_url: null,
        lang: null,
        message: '',
        name: null,
        title: null,
        client: null,
        open_cta_on_new_tab: false
      },
      block: null,
      blockErrors: new Errors()
    }
  },
  methods:{
    handleSave: function() {
      this.isSubmiting = true
      let formDataToSubmit = {...this.blockForm}
      if(this.blockForm.lang) {
        formDataToSubmit.lang = this.blockForm.lang.lang
      }
      if(this.blockForm.client) {
        formDataToSubmit.client_id = this.blockForm.client.id
      }
      if(this.blockForm.cta_url === "") {
        formDataToSubmit.cta_url = null
      }
      IframeService.updateThanksPage(this.block.id, formDataToSubmit)
      .then(res => {
        this.showToast(this.$t('iframe.blocks_builder.updated'), this.$store.state.successToastOptions)
        this.handleCancel()
      })
      .catch(errors => {
        if(errors.response.status === 422) {
          this.blockErrors.record(errors.response.data.errors, errorsPrefix)
        }
        this.showToast(this.$t('iframe.blocks_builder.update_error'), this.$store.state.errorToastOptions)
      })
      .finally(() => {
        this.isSubmiting = false
      })
    }
  },
  computed: {
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
    },
    clientOptions: function () {
      if (this.iframeService) {
        if (this.iframeService.user_permissions.some(perm => perm.entity_id === null)) {
          return this.iframeService.entities
        }
        const consideredEntitiesIds = this.iframeService.user_permissions.filter(perm => perm.access_type >= 1 && perm.info_type === 120).map(elem => elem.entity_id)
        return this.iframeService.entities.filter(entity =>  consideredEntitiesIds.includes(entity.id))
      }
      return []
    },
  }
}
</script>

<style scoped>

</style>
